function confirmSubmitAttr(message) {
    var js = 'return confirm(' + JSON.stringify(String(message)) + ');';

    return 'onsubmit="' +
        js.replace(/&/g, '&amp;')
            .replace(/"/g, '&quot;')
            .replace(/</g, '&lt;') +
        '"';
}

import dt from 'datatables.net-bs5';
import 'datatables.net-responsive-bs5';

function toggle(className, displayState) {
    var elements = document.getElementsByClassName(className);

    for (var i = 0; i < elements.length; i++) {
        elements[i].style.display = displayState;
    }
}

document.addEventListener('DOMContentLoaded', function () {

    if (document.getElementsByClassName('hfs-data-news-table').length > 0) {

        function newsTitle(data, display, row) {
            // The snippet arrives as plain text from the server; it is never
            // handed to the HTML parser here (G6.4).
            return `
                <div class="d-flex px-2 py-1">
                    <div class="d-flex flex-column justify-content-center">
                        <h6 class="mb-0 text-xs">${escapeHtml(row.title)}</h6>
                        <small>${escapeHtml(row.excerpt || '')}</small>
                    </div>
                </div>
            `;
        }

        function newsPublishAt(data, display, row) {
            return escapeHtml(row.publish_at_formatted || 'Immediately');
        }

        function newsEnabled(data, display, row) {

            if (row.status === 'live') {
                return `
                    <span class="badge text-light rounded-pill bg-success">
                        <i class="fa fa-check fa-fw"></i>
                    </span>
                `;
            }

            if (row.status === 'scheduled') {
                return `
                    <span class="badge text-dark rounded-pill bg-warning" title="Scheduled">
                        <i class="fa fa-clock fa-fw"></i>
                    </span>
                `;
            }

            return `
                <span class="badge bg-danger rounded-pill" title="Draft">
                    <i class="fa fa-remove fa-fw"></i>
                </span>
            `;
        }

        function newsTags(data, display, row) {
            if (!row.tags || row.tags.length === 0) {
                return '-';
            }

            return row.tags.map(function (tag) {
                return `<span class="badge bg-light text-dark">${escapeHtml(tag)}</span>`;
            }).join(' ');
        }

        function newsButtons(data, display, row) {

            var token = document
                .querySelector('meta[name="csrf-token"]')
                .getAttribute('content');

            return `
                <div class="btn-group">
                    <a href="/news/${row.id}" class="btn btn-outline-secondary btn-sm" title="Show news article">
                       <i class="fa fa-eye fa-fw"></i> Show
                    </a>
                    <a href="/news/${row.id}/edit" class="btn btn-outline-secondary btn-sm" title="Edit news article">
                        <i class="fa fa-pencil fa-fw"></i> Edit
                    </a>
                    <form method="POST" action="/news/${row.id}" accept-charset="UTF-8" ${confirmSubmitAttr(
                        'Do you really want to archive the news article ' +
                        row.title +
                        '?'
            )}>

                        <input name="_method" type="hidden" value="DELETE">
                        <input name="_token" type="hidden" value="${token}">
                        <button type="submit" class="btn btn-outline-danger hfs-btn-table-delete btn-sm">
                            <i class="fa fa-trash fa-fw"></i> Archive
                        </button>
                    </form>
                </div>
            `;
        }

        function escapeHtml(value) {

            if (value === null || value === undefined) {
                return '';
            }

            return String(value)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;');
        }

        var columns = [
            {
                data: 'image_url',
                orderable: false,
                searchable: false,
                render: function (data, type, row) {
                    if (!data) {
                        return `
                            <img
                                src="/assets/img/placeholder.webp"
                                alt=""
                                class="rounded"
                                style="width:60px;height:45px;object-fit:cover;"
                            >
                        `;
                    }
                    return `
                        <img
                            src="${data}"
                            alt=""
                            class="rounded"
                            style="width:60px;height:45px;object-fit:cover;"
                        >
                   `;
                }
            },
            {
                data: 'title',
                render: function (data, type, row) {
                    return newsTitle(data, type, row);
                },
                className: 'align-middle'
            },
            {
                data: 'category',
                className: 'align-middle'
            },
            {
                data: 'publish_at',
                render: function (data, type, row) {
                    return newsPublishAt(data, type, row);
                },
                className: 'align-middle',
                width: 180
            },
            {
                data: 'enabled',
                render: function (data, type, row) {
                    return newsEnabled(data, type, row);
                },
                className: 'align-middle text-center',
                width: 80
            },
            {
                data: 'tags',
                render: function (data, type, row) {
                    return newsTags(data, type, row);
                },
                className: 'align-middle'
            },
            {
                data: 'actions',
                render: function (data, type, row) {
                    return newsButtons(data, type, row);
                },
                className: 'align-middle text-end',
                width: 300
            }
        ];

        let table = new dt('.hfs-data-news-table', {

            serverSide: true,

            lengthMenu: [
                [10, 25, 50, -1],
                [10, 25, 50, "All"]
            ],

            columns: columns,

            rowId: 'id',

            order: [[2, 'desc']],

            ajax: {
                url: '/news/ajax/json',

                data: function (d) {

                    var category =
                        document.getElementById('filterNewsCategory');

                    var status =
                        document.getElementById('filterNewsStatus');

                    if (category && category.value) {
                        d.categoryId = category.value;
                    }

                    if (status && status.value) {
                        d.status = status.value;
                    }
                }
            },

            autoWidth: false,

            responsive: {
                details: {
                    type: 'column',
                    target: 'tr'
                }
            },

            initComplete: function (settings, json) {
                toggle('hfs-spinner', 'none');
                toggle('hfs-table', 'table');
                toggle('hfs-card-nav', 'flex');
            }

        });

        document
            .querySelectorAll('#filterNewsCategory, #filterNewsStatus')
            .forEach(function (el) {

                el.addEventListener('change', function () {
                    table.ajax.reload();
                });

            });
    }

});
